import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-260cacb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "element-positopn-panel" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "row tr_row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"1"} }, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "row tr_row"
}
const _hoisted_7 = {
  key: 1,
  style: {"flex":"1"}
}
const _hoisted_8 = { class: "row tr_row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"1"} }, null, -1))

import { computed, ref, watch } from 'vue'
import { round } from 'lodash'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import { ElementAlignCommands, ElementOrderCommands } from '@/types/edit'
import { MIN_SIZE } from '@/configs/element'
import { SHAPE_PATH_FORMULAS } from '@/configs/shapes'
import useOrderElement from '@/hooks/useOrderElement'
import useAlignElementToCanvas from '@/hooks/useAlignElementToCanvas'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'
import { useI18n } from 'vue-i18n'
import {
  InputNumber,
  Divider,
  Button,
  Tooltip,
} from 'ant-design-vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ElementPositionPanel',
  setup(__props) {

const { t, locale } = useI18n()

const ButtonGroup = Button.Group

const slidesStore = useSlidesStore()
const { handleElement, handleElementId } = storeToRefs(useMainStore())

const left = ref(0)
const top = ref(0)
const width = ref(0)
const height = ref(0)
const rotate = ref(0)
const fixedRatio = ref(false)

const minSize = computed(() => {
  if (!handleElement.value) return 20
  return MIN_SIZE[handleElement.value.type] || 20
})

const isHorizontalText = computed(() => {
  return handleElement.value?.type === 'text' && !handleElement.value.vertical
})
const isVerticalText = computed(() => {
  return handleElement.value?.type === 'text' && handleElement.value.vertical
})

watch(handleElement, () => {
  if (!handleElement.value) return

  left.value = round(handleElement.value.left, 1)
  top.value = round(handleElement.value.top, 1)

  fixedRatio.value = 'fixedRatio' in handleElement.value && !!handleElement.value.fixedRatio

  if (handleElement.value.type !== 'line') {
    width.value = round(handleElement.value.width, 1)
    height.value = round(handleElement.value.height, 1)
    rotate.value = 'rotate' in handleElement.value && handleElement.value.rotate !== undefined ? round(handleElement.value.rotate, 1) : 0
  }
}, { deep: true, immediate: true })

const { orderElement } = useOrderElement()
const { alignElementToCanvas } = useAlignElementToCanvas()

const { addHistorySnapshot } = useHistorySnapshot()

// 设置元素位置
const updateLeft = (value: number) => {
  const props = { left: value }
  slidesStore.updateElement({ id: handleElementId.value, props })
  addHistorySnapshot()
}
const updateTop = (value: number) => {
  const props = { top: value }
  slidesStore.updateElement({ id: handleElementId.value, props })
  addHistorySnapshot()
}

// 设置元素宽度、高度、旋转角度
// 对形状设置宽高时，需要检查是否需要更新形状路径
const updateShapePathData = (width: number, height: number) => {
  if (handleElement.value && handleElement.value.type === 'shape' && 'pathFormula' in handleElement.value && handleElement.value.pathFormula) {
    const pathFormula = SHAPE_PATH_FORMULAS[handleElement.value.pathFormula]

    let path = ''
    if ('editable' in pathFormula) path = pathFormula.formula(width, height, handleElement.value.keypoint!)
    else path = pathFormula.formula(width, height)

    return {
      viewBox: [width, height],
      path,
    }
  }
  return null
}
const updateWidth = (value: number) => {
  let props = { width: value }
  const shapePathData = updateShapePathData(value, height.value)
  if (shapePathData) props = { ...props, ...shapePathData }

  slidesStore.updateElement({ id: handleElementId.value, props })
  addHistorySnapshot()
}
const updateHeight = (value: number) => {
  let props = { height: value }
  const shapePathData = updateShapePathData(width.value, value)
  if (shapePathData) props = { ...props, ...shapePathData }

  slidesStore.updateElement({ id: handleElementId.value, props })
  addHistorySnapshot()
}
const updateRotate = (value: number) => {
  const props = { rotate: value }
  slidesStore.updateElement({ id: handleElementId.value, props })
  addHistorySnapshot()
}

// 固定元素的宽高比
const updateFixedRatio = (value: boolean) => {
  const props = { fixedRatio: value }
  slidesStore.updateElement({ id: handleElementId.value, props })
  addHistorySnapshot()
}

// 将元素旋转45度（顺时针或逆时针）
const updateRotate45 = (command: '+' | '-') => {
  let _rotate = Math.floor(rotate.value / 45) * 45
  if (command === '+') _rotate = _rotate + 45
  else if (command === '-') _rotate = _rotate - 45

  if (_rotate < -180) _rotate = -180
  if (_rotate > 180) _rotate = 180

  const props = { rotate: _rotate }
  slidesStore.updateElement({ id: handleElementId.value, props })
  addHistorySnapshot()
}

return (_ctx: any,_cache: any) => {
  const _component_IconSendToBack = _resolveComponent("IconSendToBack")!
  const _component_IconBringToFrontOne = _resolveComponent("IconBringToFrontOne")!
  const _component_IconBringToFront = _resolveComponent("IconBringToFront")!
  const _component_IconSentToBack = _resolveComponent("IconSentToBack")!
  const _component_IconAlignLeft = _resolveComponent("IconAlignLeft")!
  const _component_IconAlignVertically = _resolveComponent("IconAlignVertically")!
  const _component_IconAlignRight = _resolveComponent("IconAlignRight")!
  const _component_IconAlignTop = _resolveComponent("IconAlignTop")!
  const _component_IconAlignHorizontally = _resolveComponent("IconAlignHorizontally")!
  const _component_IconAlignBottom = _resolveComponent("IconAlignBottom")!
  const _component_IconLock = _resolveComponent("IconLock")!
  const _component_IconUnlock = _resolveComponent("IconUnlock")!
  const _component_IconRotate = _resolveComponent("IconRotate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(`editor.toolbar.elementPositionPanel.layer`)) + "：", 1),
    _createVNode(_unref(ButtonGroup), { class: "row tr_row" }, {
      default: _withCtx(() => [
        _createVNode(_unref(Button), {
          style: {"flex":"1"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(orderElement)(_unref(handleElement)!, _unref(ElementOrderCommands).TOP)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconSendToBack, { class: "btn-icon" }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t(`editor.toolbar.elementPositionPanel.top`)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Button), {
          style: {"flex":"1"},
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(orderElement)(_unref(handleElement)!, _unref(ElementOrderCommands).BOTTOM)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconBringToFrontOne, { class: "btn-icon" }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t(`editor.toolbar.elementPositionPanel.bottom`)), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(ButtonGroup), { class: "row tr_row" }, {
      default: _withCtx(() => [
        _createVNode(_unref(Button), {
          style: {"flex":"1","padding":"0"},
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(orderElement)(_unref(handleElement)!, _unref(ElementOrderCommands).UP)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconBringToFront, { class: "btn-icon" }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t(`editor.toolbar.elementPositionPanel.up`)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Button), {
          style: {"flex":"1","padding":"0"},
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(orderElement)(_unref(handleElement)!, _unref(ElementOrderCommands).DOWN)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconSentToBack, { class: "btn-icon" }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t(`editor.toolbar.elementPositionPanel.down`)), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(Divider)),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t(`editor.toolbar.elementPositionPanel.align`)) + "：", 1),
    _createVNode(_unref(ButtonGroup), { class: "row tr_row" }, {
      default: _withCtx(() => [
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: _unref(t)(`public.font.left`)
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), {
              style: {"flex":"1"},
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(alignElementToCanvas)(_unref(ElementAlignCommands).LEFT)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconAlignLeft)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay", "title"]),
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: _unref(t)(`public.font.horizontalCenter`)
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), {
              style: {"flex":"1"},
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(alignElementToCanvas)(_unref(ElementAlignCommands).HORIZONTAL)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconAlignVertically)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay", "title"]),
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: _unref(t)(`public.font.right`)
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), {
              style: {"flex":"1"},
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(alignElementToCanvas)(_unref(ElementAlignCommands).RIGHT)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconAlignRight)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay", "title"])
      ]),
      _: 1
    }),
    _createVNode(_unref(ButtonGroup), { class: "row tr_row" }, {
      default: _withCtx(() => [
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: _unref(t)(`public.font.top`)
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), {
              style: {"flex":"1"},
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(alignElementToCanvas)(_unref(ElementAlignCommands).TOP)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconAlignTop)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay", "title"]),
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: _unref(t)(`public.font.verticalCenter`)
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), {
              style: {"flex":"1"},
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(alignElementToCanvas)(_unref(ElementAlignCommands).VERTICAL)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconAlignHorizontally)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay", "title"]),
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: _unref(t)(`public.font.bottom`)
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), {
              style: {"flex":"1"},
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(alignElementToCanvas)(_unref(ElementAlignCommands).BOTTOM)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconAlignBottom)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay", "title"])
      ]),
      _: 1
    }),
    _createVNode(_unref(Divider)),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(InputNumber), {
        prefix: _unref(t)(`public.font.horizontal`) + '：',
        step: 5,
        value: left.value,
        onChange: _cache[10] || (_cache[10] = value => updateLeft(value as number)),
        style: {"flex":"4"}
      }, null, 8, ["prefix", "value"]),
      _hoisted_5,
      _createVNode(_unref(InputNumber), {
        prefix: _unref(t)(`public.font.vertical`) + '：',
        step: 5,
        value: top.value,
        onChange: _cache[11] || (_cache[11] = value => updateTop(value as number)),
        style: {"flex":"4"}
      }, null, 8, ["prefix", "value"])
    ]),
    (_unref(handleElement)!.type !== 'line')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_unref(InputNumber), {
            prefix: _unref(t)(`public.font.width`) + '：',
            min: _unref(minSize),
            max: 1500,
            step: 5,
            disabled: _unref(isVerticalText),
            value: width.value,
            onChange: _cache[12] || (_cache[12] = value => updateWidth(value as number)),
            style: {"flex":"4"}
          }, null, 8, ["prefix", "min", "disabled", "value"]),
          (['image', 'shape', 'audio'].includes(_unref(handleElement)!.type))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (fixedRatio.value)
                  ? (_openBlock(), _createBlock(_unref(Tooltip), {
                      key: 0,
                      mouseLeaveDelay: 0,
                      mouseEnterDelay: 0.5,
                      title: _unref(t)(`editor.toolbar.elementPositionPanel.noRixedRatio`)
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_IconLock, {
                          style: {"flex":"1"},
                          class: "icon-btn",
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (updateFixedRatio(false)))
                        })
                      ]),
                      _: 1
                    }, 8, ["mouseEnterDelay", "title"]))
                  : (_openBlock(), _createBlock(_unref(Tooltip), {
                      key: 1,
                      mouseLeaveDelay: 0,
                      mouseEnterDelay: 0.5,
                      title: _unref(t)(`editor.toolbar.elementPositionPanel.rixedRatio`)
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_IconUnlock, {
                          style: {"flex":"1"},
                          class: "icon-btn",
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (updateFixedRatio(true)))
                        })
                      ]),
                      _: 1
                    }, 8, ["mouseEnterDelay", "title"]))
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_7)),
          _createVNode(_unref(InputNumber), {
            prefix: _unref(t)(`public.font.height`) + '：',
            min: _unref(minSize),
            max: 800,
            step: 5,
            disabled: _unref(isHorizontalText) || _unref(handleElement)!.type === 'table',
            value: height.value,
            onChange: _cache[15] || (_cache[15] = value => updateHeight(value as number)),
            style: {"flex":"4"}
          }, null, 8, ["prefix", "min", "disabled", "value"])
        ]))
      : _createCommentVNode("", true),
    (!['line', 'video', 'audio'].includes(_unref(handleElement)!.type))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_unref(Divider)),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_unref(InputNumber), {
              prefix: _unref(t)(`public.font.rotate`) + '：',
              min: -180,
              max: 180,
              step: 5,
              value: rotate.value,
              onChange: _cache[16] || (_cache[16] = value => updateRotate(value as number)),
              style: {"flex":"8"}
            }, null, 8, ["prefix", "value"]),
            _hoisted_9,
            _createElementVNode("div", {
              class: "text-btn",
              onClick: _cache[17] || (_cache[17] = ($event: any) => (updateRotate45('-'))),
              style: {"flex":"5"}
            }, [
              _createVNode(_component_IconRotate),
              _createTextVNode(" -45°")
            ]),
            _createElementVNode("div", {
              class: "text-btn",
              onClick: _cache[18] || (_cache[18] = ($event: any) => (updateRotate45('+'))),
              style: {"flex":"5"}
            }, [
              _createVNode(_component_IconRotate, {
                style: _normalizeStyle({ transform: 'rotateY(180deg)' })
              }, null, 8, ["style"]),
              _createTextVNode(" +45°")
            ])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})